import React, { useState } from 'react';
import { useField, useFormikContext } from 'formik';
import styles from "layout/Auth/Auth.module.scss";
import { AttachmentIcon, DocumentIcon, RemoveIcon } from "Assets/icons";
import { Button } from "react-bootstrap";
import { uploadFile } from "utils/common";
import { useUploadFileMutation } from "store/services/utility";
import LoadingIndicator from "../LoadingIndicator";
import { isArray, isEmpty } from "lodash";
import ConfirmationPop from 'components/Modals/ConfirmationPop';
import { useDeleteResourceMutation } from 'store/services/resource';
import { CommonToolTip } from 'components/Common/Common';

const AppFileUploadField = ({ label, acl, allowedTypes = [], onChange, preview, hidePreview, multiple, ...props }) => {
  const [uploadFile, { isLoading: isUploading }] = useUploadFileMutation();
  const { setFieldValue, values } = useFormikContext();
  const [field, meta] = useField(props);
  const [customError, setCusomError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [cuttentIndex, setCurrentIndex] = useState(-1);

  const [removeFileApi, { isLoading: isRemoving }] = useDeleteResourceMutation();

  const handleFileChange = async (event) => {
    const input = event.currentTarget;
    try {
      if (multiple) {
        const files = event.currentTarget.files;
        const valuesArray = [];
        for (let file of files) {
          if (allowedTypes.length && !allowedTypes.includes(file.type)) {

            setCusomError(`Only ${allowedTypes?.map(i => i)?.join()?.replace(/,/g, " , ")} format is allowed`);
            // alert('File type not allowed.');
            input.value = "";
            return;
          }
          else setCusomError(null);

          const response = await uploadFile({ file, acl });
          if (!response?.error) valuesArray.push(response?.data);
        };

        if (valuesArray.length && typeof onChange === "function") onChange(field.name, valuesArray);
        return;
      };

      const file = event.currentTarget.files[0];
      if (file) {
        console.log("file.type", file.type, allowedTypes)
        if (allowedTypes.length && !allowedTypes.includes(file.type)) {

          setCusomError(`Only ${allowedTypes?.map(i => i)?.join()?.replace(/,/g, " , ")} format is allowed`);
          // alert('File type not allowed.');
          input.value = "";
          return;
        }
        else setCusomError(null);

        const response = await uploadFile({ file, acl });
        if (!response?.error) {
          if (typeof onChange === "function") {
            onChange(field.name, response?.data);
          } else {
            setFieldValue(field.name, response?.data);
          }
        }
      }
    } catch (err) {
      console.error("Error uploading file:", err);
    } finally {
      input.value = "";
    }
  };

  const handleRemoveFile = async (index) => {

    if (index || index == 0) {

      const files = [...values[field.name]];
      const file = { ...files[index] }
      delete files[index];
      setFieldValue(field.name, files.filter(Boolean));
      if (file?.id) await removeFileApi(file?.id);
    }
    else setFieldValue(field.name, isArray(values[field.name]) ? [] : "");
  };

  return (
    <>
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={() => {
          setShowModal(false)
          handleRemoveFile(cuttentIndex)
        }}
        type="delete"
      />
      <div className="iconWithText position-relative">
        <input
          type="file"
          onChange={handleFileChange}
          className={`${styles.formControl} form-control`}
          multiple={multiple}
          {...props}
        />
        <span
          className="icn position-absolute"
          style={{ right: 5 }}
        >
          <AttachmentIcon />
        </span>
        {isUploading && (
          <span
            className="icn position-absolute"
            style={{ right: 25 }}
          >
            <LoadingIndicator inline />
          </span>
        )}
      </div>
      <ul
        className={`${styles.list} list-unstyled ps-2 mb-0 pt-2`}
        style={{ maxWidth: 300 }}
      >
        {!values[field.name] ? (
          null
        ) : isArray(values[field.name]) ? (
          values[field.name].map((item, index) => {
            return (
              !hidePreview && <SingleUploadedFile
                value={item?.attachment_name || item}
                handleRemoveFile={handleRemoveFile}
                index={index}
                hidePreview={hidePreview}
                setShowModal={setShowModal}
                setCurrentIndex={setCurrentIndex}

              />
            )
          })
        ) : (
          <>
            <SingleUploadedFile
              value={values[field.name]}
              handleRemoveFile={handleRemoveFile}
              preview={preview}
              setShowModal={setShowModal}
              setCurrentIndex={setCurrentIndex}
            />
          </>

        )}
      </ul>
      {(meta.touched && meta.error) || customError ? (
        <div className="error">{meta?.error || customError}</div>
      ) : null}
    </>
  );
};

const SingleUploadedFile = ({ value, handleRemoveFile, index, preview, hidePreview, setShowModal, setCurrentIndex }) => {
  return (
    <li className="d-flex align-items-center justify-content-between gap-10">
      {
        preview ? (<img src={value} className='w-100' />) : (
          <div className="left d-flex align-items-center">
            <span className="icn me-2">
              <DocumentIcon />
            </span>
            <CommonToolTip
              component={<p className="m-0 text-muted">
                {value?.length > 40 ? `${value.slice(0, 40)}...` : value}
              </p>}
              text={value}
            />
          </div >
        )
      }
      <Button
        className="border-0 p-0"
        variant={"transparent"}
        onClick={() => {

          setCurrentIndex(index)
          setShowModal(true);

          //  handleRemoveFile(index)
        }}
      >
        <RemoveIcon />
      </Button>
    </li >
  )
}

export default AppFileUploadField;
